import { useMemo } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { ResourcesNamesInfo } from "./useDeleteResources";

export const useDeleteResourcesNotifications = (
  { projects, layers, tables }: ResourcesNamesInfo,
  resourceType: ResourceTypeLink,
  deletedResources?: string[],
) => {
  const { t } = useTranslation("dialogs");

  const resourceTitles = useMemo(
    () => ({
      projects: [t("deleteResources.projectDeleted"), t("deleteResources.projectsDeleted")],
      layers: [t("deleteResources.layerDeleted"), t("deleteResources.layersDeleted")],
      tables: [t("deleteResources.tableDeleted"), t("deleteResources.tablesDeleted")],
    }),
    [t],
  );

  return useMemo(() => {
    const currentResources = { projects, layers, tables }[resourceType];
    const resourcesCount =
      deletedResources &&
      deletedResources.filter(name => currentResources.find(resource => resource.name === name)).length;
    const isMultiDelete = resourcesCount > 1;

    const firstName = resourcesCount && deletedResources?.[0];

    const firstResource =
      firstName && currentResources.length && currentResources.find(resource => resource.name === firstName);

    const firstAlias = firstResource && (firstResource.alias || firstResource.name);

    const title = resourceTitles[resourceType]?.[0];
    const multiTitle = resourceTitles[resourceType]?.[1];

    return {
      title: isMultiDelete ? multiTitle : title,
      description: isMultiDelete ? `${firstAlias}, ${t("deleteResources.and")} ${resourcesCount - 1}` : firstAlias,
    };
  }, [projects, layers, tables, resourceType, deletedResources, resourceTitles, t]);
};
